import { render, staticRenderFns } from "./ex-steps.vue?vue&type=template&id=515248f3&scoped=true&"
import script from "./ex-steps.vue?vue&type=script&lang=js&"
export * from "./ex-steps.vue?vue&type=script&lang=js&"
import style0 from "./ex-steps.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ex-steps.vue?vue&type=style&index=1&id=515248f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515248f3",
  null
  
)

export default component.exports